import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InputSwitchModule} from "primeng/inputswitch";
import {FormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";
import {LabelWidth} from '../../../../defaults';

@Component({
  standalone: true,
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  imports: [
    InputSwitchModule,
    FormsModule,
    NgIf
  ],
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {


    @Input()
    label = '';

    get hasLabel(): boolean {
        return this.label !== '';
    }

    @Input()
    labelWidth = LabelWidth;

    @Input()
    model = false;

    @Output()
    modelChange = new EventEmitter<boolean>();

    @Input()
    disabled = false;


    constructor() {
    }

    ngOnInit(): void {
    }

}
